import { Link } from 'react-router-dom';

export default function Nav() {
	return (
		<header className='sticky top-0 z-50 backdrop-blur supports-[backdrop-filter]:bg-slate-950/70 bg-slate-950/60 border-b border-blue-900/30'>
			<nav className='mx-auto max-w-6xl px-6 h-16 flex items-center justify-between'>
				<Link
					to='/'
					className='font-display text-xl font-semibold tracking-tight text-white'>
					Asmakam
				</Link>
				<ul className='hidden sm:flex gap-6 text-sm text-blue-100'>
					<li>
						<Link className='hover:text-blue-400 focus-ring' to='/#work'>
							Products
						</Link>
					</li>
					<li>
						<Link className='hover:text-blue-400 focus-ring' to='/sms'>
							Get Updates
						</Link>
					</li>
					<li>
						<Link className='hover:text-blue-400 focus-ring' to='/privacy'>
							Privacy
						</Link>
					</li>
					<li>
						<Link className='hover:text-blue-400 focus-ring' to='/terms'>
							Terms
						</Link>
					</li>
				</ul>
				<a
					href='mailto:team@asmakam.com'
					className='sm:ml-6 rounded-2xl bg-blue-600 text-white px-4 py-2 text-sm font-medium hover:bg-blue-500 focus-ring'>
					Get Started
				</a>
			</nav>
		</header>
	);
}
